import {CommonMessages} from '../common.messages';

export const PanelSettingsGroupsEditRiskSettingsMessages = {
    GetGroupRiskSettingsFailed: {
        key: 'GetGroupRiskSettingsFailed',
        message: 'Error while processing request to the server. Unable to get the group\'s thresholds.'
    },
    UpdateGroupRiskSettingsFailed: {
        key: 'UpdateGroupRiskSettingsFailed',
        message: 'Error while processing request to the server. Unable to update the group\'s thresholds.'
    },
    UpdateGroupRiskSettingsSucceed: {
        key: 'UpdateGroupRiskSettingsSucceed',
        message: 'Thresholds updated.'
    },
    GroupRiskSettingsUnavailable: {
        key: 'GroupRiskSettingsUnavailable',
        message: 'Thresholds are not available for this group.'
    },
    ...CommonMessages
};
